import {CustomCode} from "../../../model/common.model";

export class  ApprovalState extends CustomCode{
  public static _registered = new Map<string, ApprovalState>();
  static APPROVED = new ApprovalState('APPROVED');
  static REJECTED = new ApprovalState('REJECTED');
  static WAITING_APPROVAL = new ApprovalState('WAITING_APPROVAL');
  static ALL = Array.from(ApprovalState._registered.values());


  constructor (code: string) {
    super(code);
    ApprovalState._registered.set(code, this);
  }

  public toTranslateKey(): string{
    return 'APPROVAL_STATE_' + this.code;
  }

  static retrieveFromCode(code: string): ApprovalState {
    const res = ApprovalState._registered.get(code);
    if (!res) {
      console.log('ApprovalState can\'t be found with code: ' + code);
      return null;
    }
    return res;
  }

}
